<template>
  <div
    v-if="currentStep"
    :class="['period-range', { 'period-range_disabled': disabled }]"
  >
    <!-- <div
      v-if="isLessDesctop"
      class="period-range__text period-range__text_title period-range__text_title_mobile"
    >
      {{ title }}
    </div> -->

    <!-- LABEL AND CONTROLS -->
    <div
      :class="[
        'period-range__label-container',
        { 'period-range__label-container_bottom': currentStepIndex % 2 === 1 }
      ]"
    >
      <div
        v-if="isLessDesctop"
        :class="[
          'period-range__control',
          'period-range__control_decrease',
          { 'period-range__control_disabled': !prevStep }
        ]"
        @click="selectStep(prevStep)"
      >
        <Minus />
      </div>

      <div
        class="period-range__label"
        :style="labelStyle"
      >
        {{ label }}
      </div>

      <div
        v-if="isLessDesctop"
        :class="[
          'period-range__control',
          'period-range__control_increase',
          { 'period-range__control_disabled': !nextStep }
        ]"
        @click="selectStep(nextStep)"
      >
        <Plus />
      </div>
    </div>
    <!-- LABEL AND CONTROLS -->

    <!-- LINE -->
    <div class="period-range__line">
      <div
        v-for="(step, index) in steps"
        :key="`step-${index}`"
        :class="[
          'period-range__dot',
          { 'period-range__dot_active': step.value === currentStep.value }
        ]"
        :data-text="`${step.distance} / ${step.period}`"
        @click="selectStep(step, $event)"
      />
    </div>
    <!-- LINE -->

    <!-- TEXT UNDERLINE -->
    <div class="period-range__text-container">
      <div v-if="isLessDesctop" class="period-range__text period-range__text_min period-range__text_min_mobile">
        <div class="text_min_mobile__bottom">{{ steps[0].distance }}</div>
        <div class="text_min_mobile__top">{{ steps[0].period }}</div>
      </div>

      <div v-if="isLessDesctop" class="period-range__text period-range__text_min period-range__text_min_mobile">
        <div class="text_max_mobile__bottom">{{ steps[steps.length - 1].distance }}</div>
        <div class="text_max_mobile__top">{{ steps[steps.length - 1].period }}</div>
      </div>
    </div>
    <!-- TEXT UNDERLINE -->
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import Minus from '@/assets/img/icons/minus.svg?inline'
  import Plus from '@/assets/img/icons/plus.svg?inline'

  export default {
    name: 'PeriodRange',
    components: { Minus, Plus },
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      steps: {
        type: Array,
        required: true,
        validator (steps) {
          return steps.every(step => {
            return 'period' in step &&
              'distance' in step &&
              'value' in step
          })
        }
      },
      title: {
        type: String,
        required: true
      },
      value: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        currentStep: null,
        isMounted: false,
        labelXPos: '',
        labelIsReady: false
      }
    },
    computed: {
      ...mapGetters(['isTablet', 'isLessDesctop']),
      label () {
        return this.getFullLabel(this.currentStep)
      },
      labelStyle () {
        return this.isLessDesctop
          ? null
          : { transform: `translateX(${this.labelXPos})` }
      },
      prevStep () {
        return this.steps[this.currentStepIndex - 1]
      },
      nextStep () {
        return this.steps[this.currentStepIndex + 1]
      },
      currentStepIndex () {
        return this.steps.findIndex(step => step.value === this.currentStep.value)
      }
    },
    created () {
      this.selectStep(this.steps.find(step => step.value === this.value) || this.steps[0])
    },
    activated () {
      window.addEventListener('resize', this.moveLabel)
    },
    mounted () {
      window.addEventListener('resize', this.moveLabel)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.moveLabel)
    },
    deactivated () {
      window.removeEventListener('resize', this.moveLabel)
    },
    methods: {
      selectStep (step) {
        if (!step) return

        this.currentStep = step
        this.$emit('input', step.value)
        this.moveLabel()
      },
      getFullLabel (step) {
        return `${step.distance} / ${step.period}`
      },
      moveLabel () {
        // move label horizontaly according to selected dot
        this.$nextTick(() => {
          const activeDotElement = document.querySelector('.period-range__dot_active')
          const label = document.querySelector('.period-range__label')
          const isFirstDot = this.currentStepIndex === 0
          const isLastDot = this.currentStepIndex === this.steps.length - 1

          if (this.isTablet && isFirstDot) {
            this.labelXPos = `${-25 + activeDotElement.offsetLeft}px`
          } else if (this.isTablet && isLastDot) {
            this.labelXPos = `${75 + activeDotElement.offsetLeft - label.offsetWidth}px`
          } else {
            this.labelXPos = `${22 + activeDotElement.offsetLeft - label.offsetWidth / 2}px`
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .period-range {
    position: relative;

    &__label {
      &-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: transform 0.3s cubic-bezier(0.17, 0.67, 0.55, 1.1);

        &_bottom {
          transform: translateY(74px);

          @include tablet {
            transform: translateY(0);
          }
        }
      }

      position: relative;
      z-index: 2;
      display: inline-block;
      font-size: 17px;
      line-height: 24px;
      transition: transform 0.3s cubic-bezier(0.17, 0.67, 0.55, 1.1);

      @include mobile {
        font-size: 15px;
        line-height: 21px;
      }
    }

    &__control {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: opacity 0.3s;

      &_disabled {
        opacity: 0.3;
      }

      &_decrease {
        height: 24px;
      }
    }

    &__line {
      display: flex;
      justify-content: space-between;
      height: 6px;
      padding: 0 66px;
      margin: 24px auto;
      background-color: rgba($c-gray-medium, 0.4);

      @include tablet {
        padding: 0 47px;
        margin: 20px auto 26px;
      }

      @include mobile {
        padding: 0 18px;
        margin: 23px auto 28px;
      }
    }

    &__dot {
      position: relative;
      width: 0;
      height: 0;
      padding: 47px 20px;
      margin: -47px -20px;
      cursor: pointer;
      transform: translateY(3px);

      @include mobile {
        padding: 20px;
        margin: -20px;
      }

      // dot
      &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 9px;
        height: 9px;
        content: "";
        background-color: $c-gray-medium;
        transition: transform 0.2s cubic-bezier(0.17, 0.67, 0.55, 1.5), background-color 0.3s linear;
        transform: translate(-50%, -50%) rotate(45deg);
      }

      @include hover {
        &::before {
          background-color: darken($c-gray-medium, 10);
        }
      }

      // text
      &::after {
        position: absolute;
        left: 50%;
        font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
        font-size: 14px;
        line-height: 20px;
        color: rgba($c-black, 0.44);
        white-space: nowrap;
        content: attr(data-text);
        transition: 0.3s;
        transform: translateX(-50%);

        @include tablet {
          display: none;
        }
      }

      &:nth-child(odd) {
        &::after {
          top: 0;
        }
      }

      &:nth-child(even) {
        &::after {
          bottom: 0;
        }
      }

      &_active {
        &::before {
          background-color: $c-black !important;
          transform: translate(-50%, -50%) rotate(45deg) scale(1.3);
        }

        &::after {
          opacity: 0;
        }
      }
    }

    &__text {
      &-container {
        display: flex;
        justify-content: space-between;
      }

      font-size: 12px;
      color: $c-gray-dark;

      &_title {
        &_mobile {
          margin-bottom: 20px;
        }
      }
    }

    .text {
      &_min_mobile,
      &_max_mobile {
        &__top,
        &__bottom {
          font-size: 14px;
          line-height: 20px;
          color: rgba($c-black, 0.44);
        }

        &__top {
          margin-top: 8px;
        }

        &__bottom {
          padding-bottom: 7px;
          border-bottom: 1px solid currentColor;
        }
      }

      &_max_mobile {
        &__top,
        &__bottom {
          text-align: right;
        }
      }
    }

    &_disabled {
      pointer-events: none;

      .period-range__control {
        visibility: hidden;
      }
    }
  }
</style>
